'use client'

import { Builder } from '@builder.io/react'

import { spacingBuilderInputs } from '@src/utils/builder.util'

import { BodiAppModule } from './BodiAppModule'

const BodiAppModuleComponent = {
  name: 'BodiAppModule',
  inputs: [
    spacingBuilderInputs.outerSpacing,
    {
      name: 'backgroundColor',
      friendlyName: 'Background Color',
      type: 'color',
      defaultValue: '#161819',
    },
    {
      name: 'appIconImage',
      friendlyName: 'App Icon',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
    },
    {
      name: 'appIconImageAlt',
      friendlyName: 'App Icon alt text',
      type: 'string',
      defaultValue: 'BODi App',
      helperText: 'Alt text for the app icon image.',
    },
    {
      name: 'ratingValue',
      friendlyName: 'Rating Value',
      type: 'text',
      localized: true,
      defaultValue: '4.9',
    },
    {
      name: 'ratingStarsImage',
      friendlyName: 'Rating Star Image',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
      helperText:
        'Single star image used to render the rating. Stars are repeated based on the rating value.',
    },
    {
      name: 'ratingText',
      friendlyName: 'Rating Text',
      type: 'text',
      localized: true,
      defaultValue: '280,000+ App Store Reviews',
    },
    {
      name: 'phoneMockupImage',
      friendlyName: 'Phone Mockup Image',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
      helperText: 'Combined phone mockup image showing devices side by side.',
    },
    {
      name: 'phoneMockupImageAlt',
      friendlyName: 'Phone Mockup alt text',
      type: 'string',
      defaultValue: 'BODi App on mobile devices',
      helperText: 'Alt text for the phone mockup image.',
    },
    {
      name: 'eyebrowText',
      friendlyName: 'Eyebrow Text',
      type: 'text',
      localized: true,
      defaultValue: 'THE BODi APP',
    },
    {
      name: 'heading',
      friendlyName: 'Heading',
      type: 'text',
      localized: true,
      defaultValue: 'Your gym. Anytime, anywhere',
    },
    {
      name: 'reviewTitle',
      friendlyName: 'Review Title',
      type: 'text',
      localized: true,
      defaultValue: 'Best Tested Workout App',
    },
    {
      name: 'reviewQuote',
      friendlyName: 'Review Quote',
      type: 'text',
      localized: true,
      defaultValue:
        '\u201C...An enormous variety of workout programs\u201D \u201Chigh-quality instruction\u201D \u201Cmultitude of fitness styles.\u201D',
    },
    {
      name: 'reviewSourceLogo',
      friendlyName: 'Review Source Logo',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
      helperText: 'Logo of the review source (e.g. CNN Underscored).',
    },
    {
      name: 'reviewSourceLogoAlt',
      friendlyName: 'Review Source Logo alt text',
      type: 'string',
      defaultValue: 'Review source',
      helperText: 'Alt text for the review source logo.',
    },
    {
      name: 'reviewDecorationImage',
      friendlyName: 'Review Decoration',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
      helperText: 'Decorative bracket/quote mark image for the review section.',
    },
    {
      name: 'platformIcons',
      friendlyName: 'Platform Icons',
      type: 'list',
      helperText: 'Icons for supported platforms (iOS, Android, Roku, Apple TV, etc.).',
      subFields: [
        {
          name: 'icon',
          friendlyName: 'Icon Image',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
        },
        {
          name: 'name',
          friendlyName: 'Platform Name',
          type: 'text',
          localized: true,
          helperText: 'Used as alt text for the icon.',
        },
      ],
    },
  ],
  defaultStyles: {
    margin: '0',
  },
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/device-mobile.svg',
}

Builder.registerComponent(BodiAppModule, BodiAppModuleComponent as any)
